import React from 'react';

import './style.scss';

// Renders a real photo when `src` is provided, otherwise a styled placeholder
// box labeled with the intended shot. Pass an imported image for `src`:
//   import kismet from '../assets/img/explore/kismet.jpg';
//   <ImagePlaceholder src={kismet} label="Kismet bayfront, late afternoon" />
const ImagePlaceholder = ({
  label,
  src,
  alt,
  ratio,
  objectPosition, // e.g. "center 70%" to bias the visible crop lower
  className = '',
  rounded = true,
  children,
}) => {
  const style = ratio ? { aspectRatio: ratio } : undefined;
  const imgStyle = objectPosition ? { objectPosition } : undefined;
  const cls = [
    'image-placeholder',
    rounded ? 'rounded' : '',
    src ? 'has-image' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={cls} style={style}>
      {src ? (
        <img
          className="ph-img"
          src={src}
          alt={alt || label || ''}
          style={imgStyle}
        />
      ) : (
        <div className="ph-inner">
          <i className="far fa-camera ph-icon" />
          {label && <span className="ph-label">{label}</span>}
        </div>
      )}
      {children}
    </div>
  );
};

export default ImagePlaceholder;
